import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
} from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MatDateFormats,
} from '@angular/material/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'cigna-mat-custom-datepicker-header',
  styles: [
    `
      .example-header {
        display: flex;
        align-items: center;
        padding: 1em;
        margin-bottom: 10px;
      }

      .example-header-label {
        flex: 1;
        height: 1em;
        font-weight: 500;
        text-align: left;
      }
      .icon-color {
        color: #585858;
        cursor: pointer;
      }
      .icons {
        margin-right: 10px;
      }
      ::ng-deep .mat-calendar-body-label {
        padding: 0px !important;
        /* display: none !important; */
      }
    `,
  ],
  template: `
    <div class="example-header">
      <span class="example-header-label">{{ periodLabel }}</span>
      <div class="icons">
        <cigna-icon
          class="icon-color"
          type="chevron-thin-left"
          (click)="previousClicked()"
        >
        </cigna-icon>
        &nbsp;&nbsp;
        <cigna-icon
          class="icon-color"
          type="chevron-thin-right"
          (click)="nextClicked()"
        >
        </cigna-icon>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatCustomDatepickerHeaderComponent<D> implements OnDestroy {
  private _destroyed$: Subject<void> = new Subject<void>();
  constructor(
    public _dateAdapter: DateAdapter<D>,
    @Inject(MAT_DATE_FORMATS) private _dateFormats: MatDateFormats,
    public _calendar: MatCalendar<D>,
    cdr: ChangeDetectorRef,
  ) {
    _calendar.stateChanges
      .pipe(takeUntil(this._destroyed$))
      .subscribe(() => cdr.markForCheck());
  }
  get periodLabel() {
    return this._dateAdapter
      .format(this._calendar.activeDate, 'YYYY')
      .toLocaleUpperCase();
  }

  previousClicked() {
    this._calendar.activeDate = this._dateAdapter.addCalendarYears(
      this._calendar.activeDate,
      -1,
    );
  }

  nextClicked() {
    this._calendar.activeDate = this._dateAdapter.addCalendarYears(
      this._calendar.activeDate,
      1,
    );
  }
  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
